import React, {FC} from 'react';

import {Trans} from '../../../../../libs/shared/core/src/helpers/internationalization/react';
import {DataEventActionsEnum} from '../../../../../libs/shared/core/src/models/tracking/dataEventActions';
import {OnboardingDataEventObject} from '../../../../../libs/shared/core/src/models/tracking/objectNames/onboardingDataEventObject';
import {useDataEventTracking} from '../../../../../libs/shared/core/src/services/tracking/dataEventTrackingContext';
import {Button} from '../../../../../libs/shared/ui/src/components/buttons/button';
import {useLinkNavigation} from '../../../../../libs/shared/ui/src/components/navigation/useLinkNavigation';
import {VisualSizesEnum} from '../../../../../libs/shared/ui/src/styles/commonStyles';
import {webinarTrainingUrl} from '../../../../store/stateless/navigationActions';

/*
 * Component.
 */

export const BottomBarWebinarTrainingButton: FC = () => {
  const {navigateToLink} = useLinkNavigation();
  const {trackDataEvent} = useDataEventTracking();

  const onClick = () => {
    navigateToLink(webinarTrainingUrl);
    trackDataEvent(DataEventActionsEnum.CLICK, OnboardingDataEventObject.WEBINAR_TRAINING);
  };

  return (
    <Button size={VisualSizesEnum.SMALL} onClick={onClick} leftIcon="dateSmall">
      <Trans id="bottom-bar-webinar-training-button">Schedule live training</Trans>
    </Button>
  );
};
